import { httpRequest, BASE_URL } from "./api-shared"
import { orgInfo, orgDetails, customerInfo } from "./dataTypes";

const ORG_URL = "org";

export const getAllOrgsApi = (): Promise<orgInfo[]> => {
  let url: string = `${BASE_URL}/${ORG_URL}`
  return httpRequest(url,
    'get'
  ).then(result => {
    if (result.success && result.data) {
      const data = result.data as orgDetails[];
      const orgs: orgInfo[] = data.map<orgInfo>(d => {
        let o = new orgInfo();
        o.Init(d);
        return o;
      });
      return orgs;
    } else {
      console.log(`${result.error!.message} \n ${result.error!.detail}`);
      throw result.error;
    }
  });
};

export const addOrgApi = (orgInfo: orgInfo): Promise<orgInfo> => {
  return httpRequest(`${BASE_URL}/${ORG_URL}`,
    'post', orgInfo
  ).then(r => {
    if (r.success === true && r.data) {
      return r.data as orgInfo;
    } else {
      console.log(`Error Adding Org ${orgInfo.name} ${r.error!.message} ${r.error!.detail}`);
      throw (r.error);
    }
  });
};

export const editOrgApi = (orgInfo: orgInfo): Promise<orgInfo> => {
  return httpRequest(`${BASE_URL}/${ORG_URL}`,
    'put', orgInfo
  ).then(res => {
    if (res.success === true && res.data) {
      return res.data as orgInfo;
    } else {
      console.log(res.error!.message);
      throw (res.error);
    }
  });
};

export const getCustomersListApi = (): Promise<customerInfo[]> => {
  return httpRequest(`${BASE_URL}/${ORG_URL}/customers`,
    'get'
  ).then(result => {
    if (result.success) {
      return result.data as customerInfo[];
    } else {
      console.log("Error getting customers, " + result.error!.message);
      throw (result.error);
    }
  });
}

export const editCustomerApi = (customer: customerInfo): Promise<customerInfo> => {
  return httpRequest(`${BASE_URL}/${ORG_URL}/customers`,
    'put', customer
  ).then(result => {
    if (result.success) {
      return result.data as customerInfo;
    } else {
      console.log("Error updating customer, " + result.error!.message);
      throw (result.error);
    }
  });
};

export const addCustomerApi = (customer: customerInfo): Promise<customerInfo> => {
  return httpRequest(`${BASE_URL}/${ORG_URL}/customers`,
    'post', customer
  ).then(res => {
    if (res.success === true && res.data) {
      return res.data as customerInfo;
    } else {
      console.log("Error adding customer, " + res.error!.message);
      throw (res.error);
    }
  });
}
